import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ROUTING_URLS } from './core/constants/config';

const routes: Routes = [
  { path: '', redirectTo: `/${ROUTING_URLS.dashboard}`, pathMatch: 'full' },
  {
    path: ROUTING_URLS.dashboard,
    loadChildren: () => import('./pages/dashboard/dashboard.module').then((m) => m.DashboardModule),
  },
  { path: '**', redirectTo: `/${ROUTING_URLS.dashboard}` },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { scrollPositionRestoration: 'top' })
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }
